import { countries as Countries } from "@/store/modules/countries"

export const countries = Countries

/* user/members types */
export const BASIC = "BASIC"
export const usersTypes = ["ADMIN", "ADVANCED", BASIC]

export const orgTypes = {
  MLC: "MLC",
  PRODUCER: "PRODUCER",
}

export const statusTypes = {
  // Members, Users
  ACTIVE: "active",
  BLOCKED: "blocked",
  PENDING: "pending",

  // Landing SRs
  CREATED: "created_srs",
  LINKED: "linked_srs",
  MANUALLY_CREATED: "manually_created_srs",
  MANUALLY_LINKED: "manually_linked_srs",
  PENDING_FOR_VALIDATION: "pending_for_validation",

  // Claims, SoundRecordings
  CLAIMED: "claimed",
  UNCLAIMED: "unclaimed",
  OVERCLAIMED: "overclaimed",
  UNDERCLAIMED: "underclaimed",

  // Files
  INGESTED: "ingested",
  LANDED: "landed",
  MATCHED: "matched",
  PROCESSED: "processed",
  PROCESSING: "processing",
  ERROR: "error",

  // Usages
  UNMATCHED: "unmatched",
  UNMATCHED_NO_DUPLICATES: "unmatched_no_duplicates",
  AUTOMATCHED: "automatched",
  MANUALLY_MATCHED: "manually_matched",
  AUTO_MANUALLY_MATCHED: "auto_manually_matched",
  UNMATCHED_READY_FOR_DISTRIBUTION: "unmatched_ready_for_distribution",

  // Distribution
  DISTRIBUTED: "distributed",
  DONE: "done",
  DRAFT: "draft",
}

export const fileTypes = {
  SOUNDSYS: "soundsys",
  DDEX_1_3: "ddex_mlc_v1_3",
  DDEX_1_4: "ddex_mlc_v1_4"
}